var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ container: !_vm.isReport }},[(_vm.loaded)?_c('BarLineChart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }